import { UploadsApi } from "@/api/uploads.api";
import { deleteUploadGuarded } from "@/utils/deleteUploadGuarded";
import type { ImageFile } from "@/utils/types/types";
import { atom } from "nanostores";

export const $uploads = atom<ImageFile[]>([]);

export const UploadsService = {
  async getUploads() {
    const uploads = await UploadsApi.getUploads();
    $uploads.set(uploads.data);
    return uploads.data;
  },

  async deleteImageOptimistic(imageToDelete: ImageFile) {
    const currentUploads = $uploads.get();
    const optimisticUploads = currentUploads.filter(
      img => img.url !== imageToDelete.url
    );
    $uploads.set(optimisticUploads);

    try {
      // Cart-reference guard: prompts (and may cancel) when a live cart
      // still points at the file. Cancel restores the row.
      const deleted = await deleteUploadGuarded(imageToDelete);
      if (!deleted) {
        $uploads.set(currentUploads);
        return;
      }
    } catch (error) {
      console.error("Failed to delete image:", error);
      $uploads.set(currentUploads);
      alert("Failed to delete image. Please try again.");
      throw error;
    }
  },

  async hideImageOptimistic(imageToHide: ImageFile) {
    const currentUploads = $uploads.get();
    const optimisticUploads = currentUploads.filter(
      img => img.url !== imageToHide.url
    );
    $uploads.set(optimisticUploads);

    try {
      await UploadsApi.hideFileByUrl(imageToHide.url);
    } catch (error) {
      console.error("Failed to hide image:", error);
      $uploads.set(currentUploads);
      alert("Failed to hide image. Please try again.");
      throw error;
    }
  },
};
